/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Intervention_Plan_Subtitle_ImportInputs */



/**
* | output |
* | --- |
* | "Import an intervention" |
*
* @param {Intervention_Plan_Subtitle_ImportInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const intervention_plan_subtitle_import = /** @type {((inputs?: Intervention_Plan_Subtitle_ImportInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Intervention_Plan_Subtitle_ImportInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Import an intervention")
	return /** @type {LocalizedString} */ ("Importer une intervention")
});